export const COMMON_HEADERS_KEYS = {
  CONTENT_TYPE: 'Content-Type',
  X_VOLT_APP_AUTHORIZATION: 'X-Volt-App-Authorization',
  X_VOLT_API_VERSION: 'X-Volt-Api-Version',
  X_VOLT_APP: 'X-Volt-App',
  X_VOLT_SERVICE: 'X-Volt-Service',
  X_VOLT_INITIATION_CHANNEL: 'X-Volt-Initiation-Channel',
} as const;
